import { pluralize } from '@pepper/utils/src/function/pluralize'

import s from './SelectedTopicsHeader.module.css'

const MAX_TOPICS_DISPLAY_COUNT = 4

type SelectedTopicsHeaderProps = {
  selectedTopics: {
    id: string
    name: string
  }[]
}

export const SelectedTopicsHeader: React.FC<SelectedTopicsHeaderProps> = ({
  selectedTopics,
}) => {
  const firstFourTopics =
    selectedTopics.length > MAX_TOPICS_DISPLAY_COUNT
      ? selectedTopics.slice(0, MAX_TOPICS_DISPLAY_COUNT)
      : selectedTopics

  const remainingTopicsCount = selectedTopics.length - firstFourTopics.length

  return (
    <div className={s.fieldWrapper}>
      <p className={s.bold}>
        {pluralize(selectedTopics.length, 'topic')} selected&nbsp;
        <span className={s.required}>*</span>
      </p>
      <ul className={s.topics}>
        {firstFourTopics.map(topic => (
          <li key={topic.id}>{topic.name}</li>
        ))}
        {!!remainingTopicsCount && (
          <li>+{pluralize(remainingTopicsCount, 'more topic')}</li>
        )}
      </ul>
    </div>
  )
}
